import React from "react";
import { cn } from "@/lib/utils";
import { buttonVariants } from "../DesignSystem/index.styles";
import { Loader2 } from "lucide-react";

interface NavigationButtonsProps {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
  canGoBack?: boolean;
  className?: string;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  onSubmit,
  isSubmitting = false,
  canGoBack = true,
  className,
}) => {
  const isLastStep = currentStep === totalSteps;

  return (
    <div className={cn("flex justify-between gap-3", className)}>
      {currentStep > 1 && canGoBack ? (
        <button
          type="button"
          onClick={onBack}
          disabled={isSubmitting}
          className={cn(
            buttonVariants({ variant: "ghost", size: "md" }),
            "disabled:opacity-50"
          )}
        >
          Zurück
        </button>
      ) : (
        <div />
      )}

      {isLastStep ? (
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className={cn(
            buttonVariants({ variant: "default", size: "md" }),
            "disabled:opacity-50"
          )}
        >
          {isSubmitting ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Wird gesendet...
            </>
          ) : (
            "Absenden"
          )}
        </button>
      ) : (
        <button
          type="button"
          onClick={onNext}
          disabled={isSubmitting}
          className={cn(
            buttonVariants({ variant: "default", size: "md" }),
            "disabled:opacity-50"
          )}
        >
          Weiter
        </button>
      )}
    </div>
  );
};

export default NavigationButtons;
